import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectionCard } from 'components/SelectionCard/SelectionCard';
import styles from '../SelectCatalogSizeStep.scss';
import { CatalogSize } from 'config/enums';
import { catalogSizeItemProps } from 'config/maps';
import { useAppStore } from 'stores/state';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectCatalogSizeStepOptions: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const catalogSize = useAppStore((state) => state.catalogSize);
  const setCatalogSize = useAppStore((state) => state.setCatalogSize);

  const handleSelectCatalogSize = (size: CatalogSize) => {
    setCatalogSize(size);
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SelectCatalogSize],
      button_name: BI_BUTTON_NAME.OPTION_SELECTED,
      action: BI_ACTION_NAME.NEXT,
      value: size,
    });
    next();
  };

  return (
    <div className={styles.selectCatalogSizeStepOptions}>
      {Object.values(CatalogSize).map((size) => {
        const Icon = catalogSizeItemProps[size].icon;
        return (
          <SelectionCard
            title={t(`select-catalog-size-step.options.item.title.${size}`)}
            description={t(`select-catalog-size-step.options.item.description.${size}`)}
            onClick={() => handleSelectCatalogSize(size)}
            isSelected={catalogSize === size}
            icon={<Icon />}
            key={size}
          />
        );
      })}
    </div>
  );
};
